import { NamedRouteConfig } from './types';
import { InitiatePasswordResetPage } from '../pages/auth/InitiatePasswordResetPage';
import { ExecutePasswordResetPage } from '../pages/auth/ExecutePasswordResetPage';
import { SetPasswordPage } from '../pages/auth/SetPasswordPage';
import { Route } from 'vue-router';
import { ImpersonatePage } from '@/ui/pages/auth/ImpersonatePage';
import { parseIdFromRoute } from '@/ui/routes/authenticatedRoutes';
import AnalyticsBuilder from '@/ui/pages/analytics/Builder/AnalyticsBuilder.vue';
import { t } from '@/ui/i18n/i18n';

export const localeParamName = 'locale';
export const getLocale = (route: Route) => ({ locale: route.params[localeParamName] });
export const getAnalyticsProps = (route: Route) => ({
  ...parseIdFromRoute(route),
  isGuest: true,
  locale: route.query.locale ?? 'en',
});

export const guestRoutes: NamedRouteConfig[] = [
  {
    path: `/:${localeParamName}?/initiate-password-reset`,
    name: 'initiatePasswordReset',
    component: InitiatePasswordResetPage,
    props: getLocale,
  },
  {
    path: `/:${localeParamName}?/execute-password-reset`,
    name: 'executePasswordReset',
    component: ExecutePasswordResetPage,
    props: getLocale,
  },
  {
    path: `/:${localeParamName}?/password-set`,
    name: 'setPassword',
    component: SetPasswordPage,
    props: getLocale,
  },
  {
    path: '/impersonate',
    name: 'impersonate',
    component: ImpersonatePage,
  },
  {
    path: '/public/analytics/report/:id',
    name: 'publicAnalyticsReport',
    component: AnalyticsBuilder,
    props: getAnalyticsProps,
    meta: {
      title: t('common.analytics'),
      disablePadding: true,
    },
  },
];
